import type { PigmentBrowserInspectionReport } from "@pigment/browser-inspector";

export type PigmentEvidenceSummary = {
  viewports: number;
  axeViolations: number;
  axeIncomplete: number;
  consoleErrors: number;
  networkFailures: number;
  overflowViewports: number;
  unmappedBlocks: number;
};

export function summarizeEvidence(report: PigmentBrowserInspectionReport): PigmentEvidenceSummary {
  return report.evidence.reduce<PigmentEvidenceSummary>((summary, evidence) => ({
    viewports: summary.viewports + 1,
    axeViolations: summary.axeViolations + evidence.axe.violations.length,
    axeIncomplete: summary.axeIncomplete + evidence.axe.incomplete.length,
    consoleErrors: summary.consoleErrors + evidence.console.filter((entry) => entry.level === "error").length,
    networkFailures: summary.networkFailures + evidence.network.filter((entry) =>
      Boolean(entry.failure) || (typeof entry.status === "number" && entry.status >= 400)).length,
    overflowViewports: summary.overflowViewports + Number(evidence.horizontalOverflow.detected),
    unmappedBlocks: summary.unmappedBlocks + evidence.blocks.filter((block) => block.status !== "mapped").length,
  }), {
    viewports: 0,
    axeViolations: 0,
    axeIncomplete: 0,
    consoleErrors: 0,
    networkFailures: 0,
    overflowViewports: 0,
    unmappedBlocks: 0,
  });
}
